<script>
    import EyeIcon from "../icons/EyeIcon.svelte";
    import DownloadIcon from "../icons/DownloadIcon.svelte";
    import RefreshIcon from "../icons/RefreshIcon.svelte";
    import {binaryDataUrl} from "../urls";
    import {createEventDispatcher} from "svelte";

    export let existingFilename;
    export let existingId;
    export let value;
    export let fileMask;
    export let canPreview = false;
    export let prefix = "???";

    let newFilename;

    const dispatch = createEventDispatcher();

    async function onFileChange(event) {
        const file = event.target.files[0];

        newFilename = file.name;
        if (file) {
            event.target.value = '';
            value = file;
            dispatch('change', {
                data: file
            })
        }
    }

    function requestPreview() {
        dispatch('preview', {
            data: existingId
        });
    };
    let input;
    let isHovering;
</script>

<div class="inline-flex relative w-full"
     on:mouseover={() => (isHovering = true)}
     on:mouseleave={() => (isHovering = false)}
>
    <span class="icon-holder rounded-l-md">
        {prefix}
    </span>
    {#if isHovering}
        <div
            class="absolute left-0 flex flex-col z-10 transition ease-in-out hover:translate-x-0 -translate-x-1 hover:opacity-100 opacity-0">
            <div class="rounded-md flex items-center justify-items-stretch">
                <span title="Replace" class="icon-holder rounded-l-md" on:click={()=>input.click()}>
                    <RefreshIcon/>
                </span>
                {#if existingId}
                    <a title="Download" class="icon-holder" href={binaryDataUrl(existingId)}>
                        <DownloadIcon/>
                    </a>
                    {#if canPreview}
                    <span title="Preview" class="icon-holder" on:click={requestPreview}>
                        <EyeIcon/>
                    </span>
                    {/if}
                {/if}
            </div>
        </div>
    {/if}

    <span class="model-name h-8 whitespace-nowrap">
    {#if value}
        {newFilename}
    {:else if existingId}
        {existingFilename}
    {:else}
        Select file...
    {/if}
    </span>

    <input type="file" bind:this={input} accept={"." + prefix} title="" class="hidden"
           on:change={(event) => onFileChange(event)}/>
</div>
<style>
    .model-name {
        @apply p-1 inline-flex rounded-r-md bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 flex-1 min-w-0 w-fit border-gray-300
    }

    .icon-holder {
        @apply p-1 cursor-pointer inline-flex items-center text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300
    }
</style>